import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { touristsRoutesSlice } from "@common/redux/slices/entities.slice";
import { IRoute } from "@common/redux/types/articles";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function RoutesGrid() {
  const { items, total, offset } = useSelectSlice(touristsRoutesSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IRoute>
      entityType="touristroutes"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IRoute, index) => <EntityCard key={item._id} type={getCardType(index)}
        entityType="touristroutes" entity={item}/>}
    />
  );
}
